@if (appPhase === AppPhase.DealingCards || appPhase === AppPhase.Decision || appPhase === AppPhase.RoundEnd) {
    @if (game) {
        @if (gameType === GameType.DragonTiger || gameType === GameType.OpenDragonTiger) {
            <app-dragon-tiger-table [data]="game.view"></app-dragon-tiger-table>
        } @else if (gameType === GameType.Baccarat || gameType === GameType.OpenBaccarat) {
            <app-baccarat-table [data]="game.view"></app-baccarat-table>
        } @else if (gameType === GameType.ThreeHeadedDragon) {
            <app-three-headed-dragon-table [data]="game.view"></app-three-headed-dragon-table>
        }

        <div class="count-down-container count-down-{{ gameType | lowercase }}">
            <ng-content select="[count-down]"></ng-content>
        </div>

        <ng-content select="[result-change]"></ng-content>
    }
}
